/*@flow*/
import gql from 'graphql-tag';

import type { DocumentNode } from 'graphql';
export default (gql(`
  query GetListPanelProjects(
    $filters: FiltersInput!
    $first: Int
    $last: Int
    $before: String
    $after: String
    $order: String
    $orderDir: String
  ) {
    projectList(
      filters: $filters
      first: $first
      last: $last
      before: $before
      after: $after
      order: $order
      orderDir: $orderDir
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        resourceId
        type
        name
        latlon
        category
        status
        fillColor
        photo
      }
    }
  }
`): DocumentNode);
